import { useEffect, useMemo, useState } from "react";
import { onValue, ref } from "firebase/database";
import { db } from "../lib/firebase";
import {
  DEFAULT_PDF_STYLE_CONFIG,
  normalizePdfConfig,
} from "../utils/pdfDocuments";

const DEFAULT_PDF_CONFIG = {
  documents: [],
  styleConfig: DEFAULT_PDF_STYLE_CONFIG,
  updatedAt: null,
};

export default function usePdfConfig() {
  const [pdfConfig, setPdfConfig] = useState(DEFAULT_PDF_CONFIG);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const unsubscribe = onValue(
      ref(db, "pdfconfig"),
      (snap) => {
        setPdfConfig(normalizePdfConfig(snap.val()));
        setError("");
        setLoading(false);
      },
      (err) => {
        console.error("pdfconfig load error:", err);
        setError("Could not load PDF configuration.");
        setLoading(false);
      }
    );

    return () => {
      if (typeof unsubscribe === "function") unsubscribe();
    };
  }, []);

  return useMemo(
    () => ({ pdfConfig, loading, error }),
    [pdfConfig, loading, error]
  );
}
